@if (show) {
<div
  class="flex items-start p-4 border border-solid rounded-lg bg-white relative w-full w-[356px] min-w-[280px]"
  [ngClass]="[toastConfig.class, toastConfig.position]"
>
  <lib-icon
    [icon]="toastConfig.icon"
    [category]="AssetsCategory.Toast"
  ></lib-icon>

  <div class="ml-3 mr-6 text-neutral-darkest">
    <p class="font-bold text-black">{{ toastConfig.title }}</p>
    <p
      class="break-words whitespace-normal [word-break:break-word] [overflow-wrap:anywhere]"
    >
      {{ message }}
    </p>
  </div>

  <lib-icon
    class="absolute top-2 right-2 cursor-pointer"
    [icon]="ToastIcons.Close"
    [category]="AssetsCategory.Toast"
    (click)="closeToast()"
  ></lib-icon>
</div>
}
